import { useMemo } from "react";

import { ScenarioData } from "pages/app/scenario-analysis/types/scenario";
import { ScenarioCalculationData, buildScenarioCalculationData, resolveFirstCalendarYear } from "pages/app/scenario-analysis/utils/detailedCalculations";
import { SoilSightOutcomesByScenario } from "pages/app/scenario-analysis/utils/forecast";

export type ScenarioCalculationEntry = {
  scenario: ScenarioData;
  data: ScenarioCalculationData;
};

/** Per-scenario calculation rows for every scenario with outcomes, anchored on the baseline's first year. */
export const useScenarioCalculationEntries = (scenarios: ScenarioData[], soilSightOutcomes: SoilSightOutcomesByScenario | null) => {
  const firstCalendarYear = useMemo(
    () => resolveFirstCalendarYear(scenarios.find((scenario) => scenario.isBaseline)?.createdAt ?? scenarios[0]?.createdAt),
    [scenarios]
  );

  const entries = useMemo<ScenarioCalculationEntry[]>(
    () =>
      scenarios
        .filter((scenario) => (soilSightOutcomes?.[scenario.id]?.length ?? 0) > 0)
        .map((scenario) => ({ scenario, data: buildScenarioCalculationData(scenario, soilSightOutcomes?.[scenario.id], firstCalendarYear) })),
    [scenarios, soilSightOutcomes, firstCalendarYear]
  );

  return { entries };
};
